import React from 'react';
// import { renderRoutes } from 'react-router-config';
import renderRoutes from 'routes/renderRoutes';
import Header from 'components/Header';
import MainContent from 'components/MainContent';
import CookieConsent from 'components/CookieConsent';
import Footer from 'components/Footer';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { IProps, IState } from './types';
import { RootReducersState } from 'redux/reducers';
import { logOut } from 'redux/actions/components/member.action';
import service from 'bff/services/mainLayoutService';
import storageService from 'utils/storageService';
import { storageKeys } from 'constants/enums/storageKeys.enum';
import { LogInInfo } from 'bff/models/login';
import commonService from 'utils/commonService';
import { CodeId } from 'constants/enums/codeId.enum';
import { fetchResourcesAction, setLanguageAction } from 'redux/actions/resources.action';

class MainLayout extends React.Component<IProps, IState> {
  state:IState = {
    headerLinks: [],
    footerLinks: [],
    codeTables: []
  }

  componentDidMount = async () => {
    this.props.fetchResources();
    const initSettingRes = await service.fetchInitSetting(this.props.lng);
    this.setState({
      headerLinks: [...initSettingRes.headerLinks],
      footerLinks: [...initSettingRes.footerLinks],
      codeTables: [...initSettingRes.codeTables]
    });
  }

  // shouldComponentUpdate (nextProps:IProps, nextState:IState) {
  //   let shouldUpdate = nextState.headerLinks.length !== this.state.headerLinks.length;
  //   shouldUpdate = shouldUpdate || nextState.footerLinks.length !== this.state.footerLinks.length;
  //   shouldUpdate = shouldUpdate || nextProps.hasFavoriteList !== this.props.hasFavoriteList;
  //   return shouldUpdate;
  // }

  componentDidUpdate = async (prevProps: IProps) => {
    if (this.props.lng !== prevProps.lng) {
      const initSettingRes = await service.fetchInitSetting(this.props.lng);
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        headerLinks: [...initSettingRes.headerLinks],
        footerLinks: [...initSettingRes.footerLinks],
        codeTables: [...initSettingRes.codeTables]
      });
    }
  }

  render () {
    const { route } = this.props;

    let memberName = '';
    if (storageService.getItem(storageKeys.LoginInfo)) {
      const loginInfo = JSON.parse(storageService.getItem(storageKeys.LoginInfo)) as LogInInfo;
      memberName = loginInfo.wwu_name;
    }

    return (
      <>
        <Header
          fetchFavoriteComplete={this.props.fetchFavoriteComplete}
          hasFavoriteList={this.props.hasFavoriteList}
          headerLinks={this.state.headerLinks}
          memberName={memberName}
          lng={this.props.lng}
          onLogOut={this.props.onLogOut}
          onLngChange={(lng) => {
            storageService.setItem(storageKeys.Lng, lng);
            this.props.setLanguage(lng);
            service.fetchInitSetting(lng).then(res => {
              this.setState({
                headerLinks: [...res.headerLinks],
                footerLinks: [...res.footerLinks],
                codeTables: [...res.codeTables]
              });
            });
          }}
        />
        <MainContent>
          {renderRoutes(route && route.routes)}
        </MainContent>
        <CookieConsent content={commonService.getCodeMsg(this.state.codeTables, CodeId.COOKIE)} />
        <Footer
          footerLinks={this.state.footerLinks}
          codeTables={this.state.codeTables}
        />
      </>
    );
  }
};

const mapStateToProps = (state:RootReducersState) => {
  return {
    fetchFavoriteComplete: state.myFavorite.fetchFavoriteComplete,
    hasFavoriteList: state.myFavorite.hasFavorite,
    lng: state.resources.lng
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    onLogOut: () => dispatch(logOut()),
    fetchResources: () => dispatch(fetchResourcesAction()),
    setLanguage: (lng: string) => dispatch(setLanguageAction(lng))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MainLayout);
